<template>
  <div class="log-item" @click="goViewLog">
    <div class="tite-line">
      <div class="date">{{ item.logDate }}</div>
      <div class="icon" v-if="type == 2" @click="goEditLog"></div>
    </div>
    <div class="info-line">
      <div
        class="info-item"
        v-for="(gitem, gindex) in item.generalItems"
        :key="gindex"
        v-html="getGeneralItems(gitem)"
      ></div>
    </div>
    <div class="abnormal-line" v-if="getAbnormal">
      异常记录：{{ getAbnormal }}
    </div>
    <div class="img-line" v-if="item.pics">
      <img
        class="img-item"
        v-for="(item, index) in getImgList"
        :key="index"
        v-lazy="item"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      type: this.$route.params.type || 1, // 是否可编辑 1 不可编辑 2 可编辑
      orderId: this.$route.params.orderId || '',
      origin: this.$route.params.origin || 1, // 类别 1 雇主打开服务日志列表 2 月嫂打开服务日志列表
      name: this.$route.query.name || ''
    }
  },
  computed: {
    getAbnormal() {
      const { item } = this
      let str = ''
      item &&
        item.checkItems &&
        item.checkItems.forEach(checkItem => {
          checkItem.items &&
            checkItem.items.forEach(sitem => {
              str += `${sitem.checkType}、`
            })
        })
      if (str) {
        str = str.substring(0, str.length - 1)
      }
      return str
    },
    getImgList() {
      const { item } = this
      return item && item.pics ? item.pics.split(',') : []
    }
  },
  methods: {
    getGeneralItems(item) {
      const list = item.itemType && item.itemType.split('（')
      if (list && list.length === 2) {
        const str = list[1].includes('ml')
          ? `约${item.itemValue}${list[1]}`
          : `${item.itemValue}${list[1]}`
        return `${list[0]}: <span class='color'>${str.replace('）', '')}</span>`
      } else if (list.length === 1) {
        return `${list[0]}: <span class='color'>${item.itemValue}</span>`
      } else {
        return ''
      }
    },
    goEditLog(e) {
      e && e.stopPropagation()
      location.href = `/v/service-log/edit/${this.item.workLogId}?oid=${this.orderId}&name=${this.name}&cmd=share&sharetype=0&refresh=no`
    },
    goViewLog() {
      location.href = `/v/service-log/view/${this.origin}/${this.item.workLogId}?oid=${this.orderId}&cmd=share&sharetype=0&refresh=no`
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/css/mixin';
.log-item {
  background-color: #ffffff;
  padding: 0 0 rem(30px);
  width: rem(710px);
  margin-top: rem(20px);
  border-radius: rem(8px);
  .tite-line {
    height: rem(100px);
    display: flex;
    padding: 0 rem(30px);
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    .date {
      font-weight: 800;
      font-size: rem(32px);
      color: #121212;
    }
    .icon {
      width: rem(36px);
      height: rem(36px);
      background: url('//cmspic-10004025.image.myqcloud.com/f3924770-d46b-11e9-8bdf-3976ec5da829_size_54x54')
        no-repeat center;
      background-size: contain;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: rem(-20px);
        left: rem(-20px);
        bottom: rem(-20px);
        right: rem(-20px);
      }
    }
  }
  .info-line {
    line-height: rem(50px);
    margin: rem(30px) 0 0;
    padding: 0 0 0 rem(30px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: rem(28px);
    color: #666666;
    flex-wrap: wrap;
    .info-item {
      white-space: nowrap;
      margin-right: rem(32px);
    }
    .color {
      color: #121212;
    }
  }
  .abnormal-line {
    display: flex;
    align-items: center;
    background: #fff1f1;
    border-radius: 4px;
    margin: rem(30px) rem(30px) 0;
    font-size: rem(24px);
    line-height: rem(34px);
    color: #ff397e;
    padding: rem(16px) rem(20px);
  }
  .img-line {
    padding: 0 rem(30px);
    .img-item {
      margin: rem(30px) rem(10px) 0 0;
      width: rem(210px);
      height: rem(210px);
      object-fit: cover;
      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    }
  }
}
</style>
